"use strict";
module.exports = ['$http', '$filter', 'ngDroUAACommon', function ($http, $filter, ngDroUAACommon) {

        this.findAll = function (usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);

            return $http({
                method: 'GET',
                withCredentials: true,
                url: ngDroUAACommon.getUrl('api/audit')
            });
        };
        
        this.findByPageable = function (pageable, usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);
            var params =  {
                page: pageable.pageNumber, 
                size: pageable.size, 
                sort: pageable.sorting + ',' + pageable.order
            };
                        //var url = 'api/audit?page=' + pageable.pageNumber + '&size=' + pageable.size + '&sort=' + pageable.sorting + ',' + pageable.order;
            
            return $http({
                method: 'GET',
                withCredentials: true,
                url: ngDroUAACommon.getUrl('api/audit'), 
                params: params
            });
        };
        
        return {
            findAll: this.findAll,
            findByPageable: this.findByPageable
        };
    }];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/services/rest/audit.js
// module id = 399
// module chunks = 0